module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/object/assign.js
// module id = 861
// module chunks = 2